import { Injectable } from '@angular/core';
/**
 * @ignore
 */
@Injectable({
  providedIn: 'root'
})
export class sharedDataService {

  constructor() { }

  private clientId;
  private usersPage: number;
  private userSearch$: string;
  // TODO: da promenimo u subject

  get userPage() {
    return this.usersPage;
  }

  set userPage(page) {
    this.usersPage = page;
  }

  get appId() {
    return this.clientId;
  }

  set appId(id) {
    this.clientId = id;
  }

  get userSearch() {
    return this.userSearch$;
  }

  set userSearch(search) {
    this.userSearch$ = search;
  }

}
